<div fxLayout="column" fxLayoutGap="10px">
	<rpshared-contract-rates
		[formControl]="control"
		[regularTimeBasis]="data.railroadRegularTimeBasis"
		rpsharedRemoveHost
		[isTurnOnPayrollFeeWeekly]="data.isApplyPrevailingWage"
	></rpshared-contract-rates>
	<div mat-dialog-actions *ngIf="!isReadonly">
		<button mat-button mat-dialog-close color="warn">
			Cancel
		</button>
		<button
			mat-button
			[disabled]="control.invalid"
			color="primary"
			[mat-dialog-close]="group"
		>
			Save
		</button>
	</div>
</div>
